import React, { FunctionComponent, useEffect, useState } from 'react';
import FileDownload from 'js-file-download';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import SaveIcon from '@mui/icons-material/Save';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { IApiResult } from '../../interface/IApiResult';
import {
  API_STATUS_PROBLEM,
  DOWNLOAD_FILE_NUM,
} from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyAlert } from '../UI/MyAlert';
import { ContentDto } from '../../dto/ContentDto';
import { apiGetAtlas3D } from '../../service/apiGetAtlas3D';
import { TextDto } from '../../dto/TextDto';
import { apiSaveAtlas3D } from '../../service/apiSaveAtlas3D';
import { MyTextFiled } from '../UI/MyTextField';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { apiGetAtlas3DNew } from '../../service/apiGetAtlas3DNew';
import { AtlasNewDto } from '../../dto/AtlasNewDto';
import { apiAddAtlas3DNew } from '../../service/apiAddAtlas3DNew';
import { deleteAddAtlas3DNew } from '../../service/deleteAddAtlas3DNew';
import { MyButton } from '../UI/MyButton';
import { DialogConfirmation } from '../confirmation/DialogConfirmation';
import { apiAddAtlas3DNewFromFiles } from '../../service/apiAddAtlas3DNewFromFile';
import { apiAddAtlas3DNewToFiles } from '../../service/apiAddAtlas3DNewToFile';

interface Props {
  open: boolean;
  isEdit?: boolean;
  onClose: () => void;
  dto?: ContentDto;
}

export const DialogAtlas3DNew: FunctionComponent<Props> = ({
  open,
  dto,
  isEdit,
  onClose,
}) => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [atlasAdd2, setAtlasAdd2] = useState<AtlasNewDto>({
    angl: '',
    atlasId: '',
    id: '',
    latGaivar: '',
    latPr: '',
    latSech: '',
    latSmew: '',
    rus: '',
    scene: '',
    rusPr: '',
    rusSech: '',
    rusGaivar: '',
  });
  const [atlasAdd, setAtlasAdd] = useState<AtlasNewDto>({
    angl: '',
    atlasId: '',
    id: '',
    latGaivar: '',
    latPr: '',
    latSech: '',
    latSmew: '',
    rus: '',
    scene: '',
    rusPr: '',
    rusSech: '',
    rusGaivar: '',
  });
  const [atlas, setAtlas] = useState<AtlasNewDto[]>([]);
  const [backDrop, setBackDrop] = useState(false);
  const handleClose = () => {
    setAtlas([]);
    onClose();
  };
  const { section } = useParams();

  const getAtlas3D = async (route: string, key: string) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetAtlas3DNew(route, key);
    if (apiResult.isSuccess) {
      setAtlas(apiResult.data);
    } else if (apiResult.status !== 404) {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);
  const updateContent = async () => {
    if (atlasAdd.atlasId === '') {
      return;
    }
    setBackDrop(true);
    const apiResult: IApiResult = await apiAddAtlas3DNew(
      section ?? '',
      dto?.key ?? '',
      atlasAdd
    );
    if (apiResult.isSuccess) {
      getAtlas3D(section ?? '', dto?.key ?? '');
      setAtlasAdd({
        angl: '',
        atlasId: '',
        id: '',
        latGaivar: '',
        latPr: '',
        latSech: '',
        latSmew: '',
        rus: '',
        scene: '',
        rusPr: '',
        rusSech: '',
        rusGaivar: '',
      });
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const uploadContent = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiAddAtlas3DNewFromFiles(
      section ?? '',
      dto?.key ?? ''
    );
    if (apiResult.isSuccess) {
      getAtlas3D(section ?? '', dto?.key ?? '');
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const saveContent = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiAddAtlas3DNewToFiles(
      section ?? '',
      dto?.key ?? ''
    );
    if (apiResult.isSuccess) {
      getAtlas3D(section ?? '', dto?.key ?? '');
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const handleAdd = async () => {
    await updateContent();
  };

  const handleUpload = async () => {
    await uploadContent();
  };

  const handleSave = async () => {
    await saveContent();
  };

  const deleteContent = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogConfirmation(false);
      return;
    }
    const apiResult: IApiResult = await deleteAddAtlas3DNew(
      section ?? '',
      dto?.key ?? '',
      atlasAdd2
    );
    if (apiResult.isSuccess) {
      getAtlas3D(section ?? '', dto?.key ?? '');
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenDialogConfirmation(false);
  };

  const handleDelete = async (dtoAtlas: AtlasNewDto) => {
    setAtlasAdd2(dtoAtlas);
    setOpenDialogConfirmation(true);
  };

  const handleReset = () => {
    setAtlasAdd({
      angl: '',
      atlasId: '',
      id: '',
      latGaivar: '',
      latPr: '',
      latSech: '',
      latSmew: '',
      rus: '',
      scene: '',
      rusPr: '',
      rusSech: '',
      rusGaivar: '',
    });
  };

  useEffect(() => {
    if (open) {
      getAtlas3D(section ?? '', dto?.key ?? '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: { backgroundColor: '#e7ebee', maxWidth: '100%', height: '100%' },
        }}
      >
        <BackDropDiv open={backDrop} />
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '24px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              {`3D атлас - ${dto?.key} ${dto?.title}`}
            </Typography>
            <Stack direction="row" marginBottom="20px" spacing={1}>
              <MyButton
                text="Из файла"
                width="140px"
                background="#009688"
                onClick={handleUpload}
              />
              <MyButton
                text="В файл"
                width="140px"
                background="#009688"
                onClick={handleSave}
              />
              <IconButton title="Закрыть" size="small" onClick={handleClose}>
                <CloseIcon fontSize="large" sx={{ color: '#000000' }} />
              </IconButton>
            </Stack>
          </Stack>
          <Stack width="100%" spacing={1}>
            <Stack direction="row" width="100%" spacing={1}>
              <MyTextFiled
                value={atlasAdd.atlasId}
                onChange={(e) =>
                  setAtlasAdd({ ...atlasAdd, atlasId: e.target.value })
                }
                width="25%"
                size="small"
                label="ID"
              />
              <MyTextFiled
                value={atlasAdd.angl}
                onChange={(e) =>
                  setAtlasAdd({ ...atlasAdd, angl: e.target.value })
                }
                width="25%"
                size="small"
                label="Английский"
              />
              <Stack width="50%" direction="row" spacing={1}>
                <MyButton
                  text="Сохранить"
                  background="#9c27b0"
                  height="50px"
                  onClick={handleAdd}
                />
                <MyButton
                  text="Отмена"
                  background="#212121"
                  height="50px"
                  onClick={handleReset}
                />
              </Stack>
            </Stack>
            <Stack direction="row" width="100%" spacing={1}>
              <Stack direction="row" width="90%">
                <MyTextFiled
                  value={atlasAdd.latSmew}
                  onChange={(e) =>
                    setAtlasAdd({ ...atlasAdd, latSmew: e.target.value })
                  }
                  size="small"
                  label="Текущий латинский"
                />
              </Stack>
              <Stack direction="row" width="90%">
                <MyTextFiled
                  value={atlasAdd.latPr}
                  onChange={(e) =>
                    setAtlasAdd({ ...atlasAdd, latPr: e.target.value })
                  }
                  size="small"
                  label="Привес латинский"
                />
                <IconButton
                  title="Сохранить"
                  size="small"
                  onClick={() =>
                    setAtlasAdd({ ...atlasAdd, latPr: atlasAdd.latSmew })
                  }
                >
                  <SaveIcon fontSize="large" sx={{ color: '#2196f3' }} />
                </IconButton>
              </Stack>
              <Stack direction="row" width="90%">
                <MyTextFiled
                  value={atlasAdd.latSech}
                  onChange={(e) =>
                    setAtlasAdd({ ...atlasAdd, latSech: e.target.value })
                  }
                  size="small"
                  label="Сапин латинский"
                />
                <IconButton
                  title="Сохранить"
                  size="small"
                  onClick={() =>
                    setAtlasAdd({ ...atlasAdd, latSech: atlasAdd.latSmew })
                  }
                >
                  <SaveIcon fontSize="large" sx={{ color: '#2196f3' }} />
                </IconButton>
              </Stack>
              <Stack direction="row" width="90%">
                <MyTextFiled
                  value={atlasAdd.latGaivar}
                  onChange={(e) =>
                    setAtlasAdd({ ...atlasAdd, latGaivar: e.target.value })
                  }
                  size="small"
                  label="Гайворонский латинский"
                />
                <IconButton
                  title="Сохранить"
                  size="small"
                  onClick={() =>
                    setAtlasAdd({ ...atlasAdd, latGaivar: atlasAdd.latSmew })
                  }
                >
                  <SaveIcon fontSize="large" sx={{ color: '#2196f3' }} />
                </IconButton>
              </Stack>
            </Stack>
            <Stack direction="row" width="100%" spacing={1}>
              <Stack direction="row" width="90%">
                <MyTextFiled
                  value={atlasAdd.rus}
                  onChange={(e) =>
                    setAtlasAdd({ ...atlasAdd, rus: e.target.value })
                  }
                  size="small"
                  label="Текущий русский"
                />
              </Stack>
              <Stack direction="row" width="90%">
                <MyTextFiled
                  value={atlasAdd.rusPr}
                  onChange={(e) =>
                    setAtlasAdd({ ...atlasAdd, rusPr: e.target.value })
                  }
                  size="small"
                  label="Привес русский"
                />
                <IconButton
                  title="Сохранить"
                  size="small"
                  onClick={() =>
                    setAtlasAdd({ ...atlasAdd, rusPr: atlasAdd.rus })
                  }
                >
                  <SaveIcon fontSize="large" sx={{ color: '#2196f3' }} />
                </IconButton>
              </Stack>
              <Stack direction="row" width="90%">
                <MyTextFiled
                  value={atlasAdd.rusSech}
                  onChange={(e) =>
                    setAtlasAdd({ ...atlasAdd, rusSech: e.target.value })
                  }
                  size="small"
                  label="Сапин русский"
                />
                <IconButton
                  title="Сохранить"
                  size="small"
                  onClick={() =>
                    setAtlasAdd({ ...atlasAdd, rusSech: atlasAdd.rus })
                  }
                >
                  <SaveIcon fontSize="large" sx={{ color: '#2196f3' }} />
                </IconButton>
              </Stack>
              <Stack direction="row" width="90%">
                <MyTextFiled
                  value={atlasAdd.rusGaivar}
                  onChange={(e) =>
                    setAtlasAdd({ ...atlasAdd, rusGaivar: e.target.value })
                  }
                  size="small"
                  label="Гайворонский русский"
                />
                <IconButton
                  title="Сохранить"
                  size="small"
                  onClick={() =>
                    setAtlasAdd({ ...atlasAdd, rusGaivar: atlasAdd.rus })
                  }
                >
                  <SaveIcon fontSize="large" sx={{ color: '#2196f3' }} />
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack width="100%">
            {atlas.map(
              (item) =>
                item.atlasId !== '' && (
                  <Stack>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      sx={{
                        bgcolor: '#FFFFFF',
                        '&:hover': {
                          bgcolor: '#ce93d8',
                        },
                      }}
                    >
                      <Stack
                        direction="row"
                        width="100%"
                        alignItems="center"
                        spacing={1}
                      >
                        <Stack
                          direction="row"
                          width="100%"
                          padding="5px"
                          alignItems="center"
                          spacing={1}
                        >
                          <Stack>
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(item)}
                            >
                              <DeleteIcon
                                fontSize="small"
                                sx={{
                                  color: '#f44336',
                                }}
                              />
                            </IconButton>
                          </Stack>
                          <Stack onClick={() => setAtlasAdd(item)}>
                            <Typography
                              style={{
                                fontFamily: 'sans-serif',
                                fontStyle: 'normal',
                                fontSize: '14px',
                                color: '#000000',
                              }}
                              component="text"
                            >
                              {`${item?.atlasId}`}
                            </Typography>
                            <Typography
                              style={{
                                fontFamily: 'sans-serif',
                                fontStyle: 'normal',
                                fontSize: '12px',
                                color: '#000000',
                              }}
                              component="text"
                            >
                              {`${item?.angl}`}
                            </Typography>
                          </Stack>
                        </Stack>
                        <Divider orientation="vertical" />
                        <Stack width="100%" onClick={() => setAtlasAdd(item)}>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '10px',
                              color: '#00000080',
                            }}
                            component="text"
                          >
                            {item?.latSmew !== '' ? 'Текущий' : ''}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '14px',
                              color: '#000000',
                            }}
                            component="text"
                          >
                            {`${item?.latSmew}`}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '14px',
                              color: '#00000080',
                            }}
                            component="text"
                          >
                            {`${item?.rus}`}
                          </Typography>
                        </Stack>
                        <Divider orientation="vertical" />
                        <Stack width="100%" onClick={() => setAtlasAdd(item)}>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '10px',
                              color: '#00000080',
                            }}
                            component="text"
                          >
                            {item?.latPr !== '' ? 'Привес' : ''}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '14px',
                              color: '#000000',
                            }}
                            component="text"
                          >
                            {`${item?.latPr}`}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '14px',
                              color: '#00000080',
                            }}
                            component="text"
                          >
                            {`${item?.rusPr}`}
                          </Typography>
                        </Stack>
                        <Divider orientation="vertical" />
                        <Stack width="100%" onClick={() => setAtlasAdd(item)}>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '10px',
                              color: '#00000080',
                            }}
                            component="text"
                          >
                            {item?.latSech !== '' ? 'Сапин' : ''}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '14px',
                              color: '#000000',
                            }}
                            component="text"
                          >
                            {`${item?.latSech}`}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '14px',
                              color: '#00000080',
                            }}
                            component="text"
                          >
                            {`${item?.rusSech}`}
                          </Typography>
                        </Stack>
                        <Divider orientation="vertical" />
                        <Stack width="100%" onClick={() => setAtlasAdd(item)}>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '10px',
                              color: '#00000080',
                            }}
                            component="text"
                          >
                            {item?.latGaivar !== '' ? 'Гайворонский' : ''}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '14px',
                              color: '#000000',
                            }}
                            component="text"
                          >
                            {`${item?.latGaivar}`}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontSize: '14px',
                              color: '#00000080',
                            }}
                            component="text"
                          >
                            {`${item?.rusGaivar}`}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Divider />
                  </Stack>
                )
            )}
          </Stack>
        </DialogContent>
      </Dialog>
      <DialogConfirmation
        open={openDialogConfirmation}
        message="Вы точно хотите удалить данный пункт?"
        onClose={deleteContent}
      />
    </div>
  );
};

DialogAtlas3DNew.defaultProps = {
  isEdit: false,
  dto: undefined,
};
